/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Button, Flex, useToast } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { Layout } from 'components/atoms'
import { InputBuild } from 'components/molecules'
import React, { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import InstitutionsService from 'services/institutions'
import { DataFormControl } from './form'
import { DataForm, DataFormProps } from './interfaces'
import { Schema } from './schema'
import { DataKeys } from './types'

const Data: React.FC<DataFormProps> = ({ initial, fetchInstitution }) => {
    const defaultValue: DataForm = {
        ...initial,
        contato: initial.telefone,
        email: initial.email,
        IE: initial.ie ? initial.ie : '',
        IM: initial.im ? initial.im : ''
    }

    const {
        handleSubmit,
        register,
        watch,
        formState: { errors, isSubmitting }
    } = useForm<DataForm>({
        resolver: yupResolver(Schema),
        defaultValues: defaultValue || {}
    })

    const form = useMemo(() => DataFormControl, [])
    const toast = useToast()

    function emitToastError(error: any) {
        const message =
            error?.response?.data[0]?.mensagem ??
            'Algo deu errado, tente novamente mais tarde.'

        toast({
            title: `Falha ao Salvar Instituição Financeira`,
            description: message,
            position: 'bottom-left',
            status: 'error',
            isClosable: true
        })
    }

    function emitToastSuccess() {
        toast({
            title: `Instituição Financeira`,
            description: 'A instituição financeira foi editada com sucesso',
            position: 'bottom-left',
            status: 'success',
            isClosable: true
        })
    }

    async function fetchEditBasicDatainstitution(
        data: any,
        idInstitution: string
    ) {
        try {
            await InstitutionsService.editBasicDataInstitutions(
                data,
                idInstitution
            )
            emitToastSuccess()
            fetchInstitution()
        } catch (error: unknown) {
            emitToastError(error)
        }
    }

    const handleFormSubmit = async (data: DataForm) => {
        const payload = {
            razaoSocial: data.razaoSocial,
            email: data.email,
            telefone: data.contato.replace(/\D/g, ''),
            ie: data.IE,
            im: data.IM
        }
        await fetchEditBasicDatainstitution(payload, initial.id)
    }

    const hasError = (id: DataKeys) => {
        return errors && errors[id]
    }

    return (
        <form onSubmit={handleSubmit(handleFormSubmit)}>
            <Layout type="container" full px={6} pb={6}>
                <Layout type="row" gutter={{ y: 1.5 }}>
                    {form.map(({ layout, input }, key) => (
                        <Layout {...layout} key={key}>
                            <InputBuild
                                {...input}
                                err={hasError(input.id)}
                                {...register(input.id)}
                                value={watch(input.id) as string}
                            ></InputBuild>
                        </Layout>
                    ))}
                </Layout>
                {
                    <Flex display="flex" justifyContent="flex-end">
                        <Button
                            isLoading={isSubmitting}
                            colorScheme="primary"
                            type="submit"
                        >
                            Salvar
                        </Button>
                    </Flex>
                }
            </Layout>
        </form>
    )
}

export default Data
